import type { FunctionComponent, ReactNode } from "react";

import { StyledDiv } from "./styles";

export const Card: FunctionComponent<{ children?: ReactNode }> = StyledDiv;
Card.displayName = "Card";
